/** A keyed list that features fill at start-up; a second entry with the same id is refused. */
export interface Registry<T extends { id: string }> {
  register(entry: T): void;
  list(): T[];
}

export class DuplicateEntryError extends Error {
  override name = "DuplicateEntryError";
}

export function createRegistry<T extends { id: string }>(name: string): Registry<T> {
  const entries = new Map<string, T>();
  return {
    register(entry) {
      if (entries.has(entry.id)) {
        throw new DuplicateEntryError(`${name} already has an entry "${entry.id}"`);
      }
      entries.set(entry.id, entry);
    },
    list: () => [...entries.values()],
  };
}
